import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s16,
    },
    topWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
    },
  },
  { name: 'template-banner-carousel' },
);

export default useStyles;
